/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CurrencyDollarSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200,168a48.054,48.054,0,0,1-48,48H136v16a8,8,0,0,1-16,0V216H104a48.054,48.054,0,0,1-48-48,8,8,0,0,1,16,0,32.03635,32.03635,0,0,0,32,32h48a32,32,0,0,0,0-64H108a48,48,0,0,1,0-96h12V24a8,8,0,0,1,16,0V40h8a48.054,48.054,0,0,1,48,48,8,8,0,0,1-16,0,32.03635,32.03635,0,0,0-32-32H108a32,32,0,0,0,0,64h44A48.054,48.054,0,0,1,200,168Z" />
    </Svg>
  );
}

export default CurrencyDollarSimple;
